import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { IsCorrectLocaleGuardService } from './is-correct-locale-guard.service';

export const isCorrectLocaleGuard = (activatedRoute: ActivatedRouteSnapshot) => {
    const isCorrectLocaleGuardService = inject(IsCorrectLocaleGuardService);
    return isCorrectLocaleGuardService.canActivate(activatedRoute);
};
